import React from 'react';
import noop from 'lodash/noop';
export const DropdownStateContext = /*#__PURE__*/ React.createContext({
    isOpen: false,
    setToggleRef: noop,
    setMenuRef: noop,
    openDropdown: noop,
    closeDropdown: noop,
    toggleDropdown: noop,
    firstKeyInteraction: null
});
DropdownStateContext.displayName = 'DropdownStateContext';
export const DropdownDebugContext = /*#__PURE__*/ React.createContext({
    forceOpen: false
});
DropdownDebugContext.displayName = 'DropdownDebugContext';

//# sourceMappingURL=DropdownStateContext.js.map